<template>
  <div :id="root_ref_key"
       :ref="root_ref_key"
       class="ap-root"
       :class="bordered && 'bordered'"
       :title="hover_text"
       @dblclick="() => setMode(AP_MODES.ACTIVE)">
    <div v-if="mode === AP_MODES.PASSIVE" class="ap-passive-container">
      <i v-if="showIcon" :id="qe_icon_id_key"
         class="ap-passive-icon fa fa-edit"
         :title="hoverIconText"
         @click="() => setMode(AP_MODES.ACTIVE)" />
      <slot name="ap-passive" :val="val" />
    </div>
    <slot v-if="mode === AP_MODES.ACTIVE" name="ap-active"
          :update-val="updateValue"
          :val="val" />
  </div>
</template>

<script>

export const AP_MODES = Object.freeze({
  PASSIVE: Symbol(`passive`),
  ACTIVE: Symbol(`active`),
});

let ID_INDEX = 0;

// initial idea is totally buggy, for some reason vue mounts totally new
// components when the slots get changed, just use the `<table-id>-update-row` event on FDT
export default {
  props: {
    dataVal: {
      type: null,
      required: false,
      default: null,
    },
    inputId: {
      type: String,
      required: false,
      default: null,
    },
    eventId: {
      type: String,
      required: false,
      default: null,
    },
    hoverText: {
      type: String,
      required: false,
      default: `Double click to edit`,
    },
    hoverIconText: {
      type: String,
      required: false,
      default: `Click to edit`,
    },
    bordered: {
      type: Boolean,
      required: false,
      default: false,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    toggleEvent: {
      type: String,
      reuired: false,
      default: 'dblclick',
    },
  },
  data: () => ({
    ref_id: null,
    mode: AP_MODES.PASSIVE,
    val: null,
  }),
  computed: {
    AP_MODES() {
      return AP_MODES;
    },
    root_ref_key() {
      return `ap-root-${this.ref_id}`;
    },
    qe_icon_id_key() {
      return `${this.root_ref_key}-qe-icon`;
    },
    qe_icon_el() {
      return document.getElementById(this.qe_icon_id_key);
    },
    root_el() {
      return document.getElementById(this.root_ref_key);
    },
    hover_text() {
      return this.mode === AP_MODES.PASSIVE ? this.hoverText : '';
    },
  },
  beforeMount() {
    // data init
    this.val = this.dataVal;
  },
  mounted() {
    // id indexing
    this.ref_id = ID_INDEX;
    ID_INDEX += 1;

    // listen for clicks outside the component
    document.addEventListener(`click`, (ev) => {
      if (
        this.qe_icon_id_key !== ev.target.id &&
        this.mode === AP_MODES.ACTIVE &&
        !this.root_el?.contains(ev.target)
      ) {
        this.setMode(AP_MODES.PASSIVE); // return to display mode if click outside
      }
    });

    EventBus.$on(`ap-update`, (ev) => {
      if (this.eventId === ev.id) {
        this.val = ev.val;
      }
    });
  },
  methods: {
    setMode(mode) {
      this.mode = mode; // update mode
      window.EventBus.$emit(`ap-toggle`, {
        id: this.eventId,
        mode: this.mode,
        val: this.val,
      });
      this.$emit(`ap-toggle`, {
        id: this.eventId,
        mode: this.mode,
        val: this.val,
      });
    },
    updateValue(val) {
      this.val = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "sass:map";

@use "~AssetsSass/_variables" as *;

.ap-root {
  &.bordered {
    border: 1px solid map.get($ss-adds, 'border-grey');
    border-radius: 4px;
  }
  .ap-passive-container {
    padding: 2px 3px;
    cursor: pointer;
    position: relative;

    .ap-passive-icon {
      position: absolute;
      bottom: -5%;
      right: -12px;
      color: color.adjust(map.get($ss-theme, 'hunter-grey'), $lightness: 30%, $space: hsl);
      padding: 0.2em;
      border-radius: 3px;
      background-color: white;
      z-index: 5;
    }

    &:hover {
      box-shadow: 0 0 3px map.get($ss, 'secondary');

      .ap-passive-icon {
        color: map.get($ss, 'secondary');

        &:hover {
          color: map.get($ss, 'secondary');
          font-weight: bold;
          text-shadow: 0 0 1px map.get($ss, 'secondary');
        }
      }
    }
  }
}
</style>
